import {OperationCardProps} from "./types";
import dayjs from "dayjs";
import {useMemo} from "react";
import {getOperationStaffNames} from "../../../../helpers/getOperationStaffNames";
import {ArrowRightOutlined, ClockCircleOutlined, MedicineBoxOutlined, UserOutlined} from "@ant-design/icons";
import "./style.less";

const OperationCard = ({cardClickHandler, item, operationStaffList}: OperationCardProps) => {
  const operationDate = dayjs(item.operationTime).locale('uk');
  const surgeons = useMemo(() => {
    return getOperationStaffNames({staffList: operationStaffList, ids: item.surgeon});
  }, [operationStaffList, item]);

  return <button className="schedule-operation-card" type="button" onClick={() => cardClickHandler(item)}>
    <time className="schedule-operation-card__time" dateTime={item.operationTime}>
      <strong className="schedule-operation-card__time-badge">
        <ClockCircleOutlined/>{operationDate.format("HH:mm")}
      </strong>
      <span className="schedule-operation-card__date">
        <strong>{operationDate.format("DD.MM.YYYY")}</strong>
        <small>{operationDate.format("dddd")}</small>
      </span>
    </time>

    <span className="schedule-operation-card__details">
      <span><UserOutlined/><span><small>Пацієнт</small><strong>{item.patientName || "Не вказано"}</strong></span></span>
      <span><MedicineBoxOutlined/><span><small>Хірург</small><strong>{surgeons.length ? surgeons.join(", ") : "Не вказано"}</strong></span></span>
    </span>

    {item.operation && <span className="schedule-operation-card__operation">{item.operation}</span>}
    <span className="schedule-operation-card__more">Детальніше <ArrowRightOutlined/></span>
  </button>;
};

export default OperationCard;
